import React, { useEffect, useRef, useState } from "react";
import arrowDown from '../assets/arrowDown.svg'
import { AiOutlineSearch } from "react-icons/ai";

const RateEventSelector = ({
    customstyle = false,
    page,
    eventError,
    setEventError,
    eventData,
    handleEventSelect,
    device,
    placeholder,
    selectedEvent,
    disabled // NEW: Disabled prop
}) => {
    const [inputValue, setInputValue] = useState("");
    const [selected, setSelected] = useState(selectedEvent || "");
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleOpen = () => {
        if (!disabled) setOpen(!open); // Prevent opening if disabled
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelected(selectedEvent || "");
    }, [selectedEvent]);

    return (
        <div
            className={`w-full relative cursor-pointer  `}
            ref={dropdownRef}
        >
            <div
                onClick={handleOpen}
                className={`w-full h-[45px] lg:h-[50px] border border-[#c1c1c180] ${eventError === "Event is required" || eventError === "Invalid Search"
                        ? " border border-[#EB0728] text-[#EB0728] "
                        : " "
                    } rounded-[80px] py-[14px] ${customstyle ? ' px-[18px] md:px-[20px] lg:px-[29px]' : ' px-[24px]'} flex items-center justify-between text-center text-base  font-normal ${!selected ? "text-[#707070]" : 'text-black '
                    } ${disabled ? "bg-ravbg text-ravash cursor-not-allowed" : ""}`}
            >
                {selected
                    ? selected.length > 15
                        ? selected.substring(0, 15) + "..."
                        : selected
                    : placeholder || "Select event type"}
               
                 <svg
                        width="13"
                        height="9"
                        viewBox="0 0 13 9"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`${eventError ? "text-[#EB0728]" : "text-[#707070]"} ${open && "rotate-180"} ${disabled ? "hidden" : ""}  ${eventError && (eventError === "Event is required" || eventError === "Invalid Search")} `}
                        fill="currentColor"
                    >
                        <path d="M6.5 8.04167L0.25 1.79167L1.36979 0.671875L6.5 5.80208L11.6302 0.671875L12.75 1.79167L6.5 8.04167Z" />
                    </svg>
            </div>

            {!disabled && open && (
                <ul className="w-full shadow-input bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-50 text-start h-[30vh]">
                    <div className="flex items-center px-2 sticky top-0 bg-white">
                        <AiOutlineSearch size={18} className="text-gray-700" />
                        <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value.toLowerCase())}
                            placeholder={placeholder || "Enter event name"}
                            className=" p-2 outline-none"
                        />
                    </div>
                    {eventData
                        ?.sort((a, b) => a?.event_name?.localeCompare(b?.event_name))
                        ?.map((event) => (
                            <li
                                key={event?.event_name}
                                className={`p-2 text-sm hover:bg-sky-600 hover:text-white
                                    ${event?.event_name?.toLowerCase() === selected?.toLowerCase() && "bg-sky-600 text-white"}
                                    ${event?.event_name?.toLowerCase().startsWith(inputValue) ? "block" : "hidden"}
                                `}
                                onClick={() => {
                                    if (event?.event_name?.toLowerCase() !== selected.toLowerCase()) {
                                        setSelected(event?.event_name);
                                        handleEventSelect(event?.event_name, event?.event_id);
                                        setOpen(false);
                                        setInputValue("");
                                    }
                                }}
                            >
                                {event?.event_name}
                            </li>
                        ))}
                </ul>
            )}
        </div>
    );
};

export default RateEventSelector;
